import { Visibility, VisibilityOff } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import { addSecret, testDbConnection } from "../../api's/ConnectorsApi";
import LoadingIcon from '../../reusable-component/LoadingIcon';
import { AWS_CONFIG_TYPE } from '../../BaseUrl';

const INITIAL_STATE = {
  secretName: '',
  engine: 'oracle',
  connectorType: 'oracle',
  host: '',
  port: '',
  database: '',
  username: '',
  password: '',
  serviceName: '',
};

const OracleDBConnectorForm = ({ open, handleClose, service }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState(INITIAL_STATE);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isConnectionSucceeded, setIsConnectionSucceeded] = useState(false);
  const [errors, setErrors] = useState({ secretName: false });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  //   if (name !== 'secretName') {
  //     setIsConnectionSucceeded(false);
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'secretName') {
      const pattern = AWS_CONFIG_TYPE
        ? /^[a-z][a-z0-9_]{0,29}$/
        : /^[a-z][a-z0-9-]{0,29}$/;

      const isValid = pattern.test(value);
      setErrors((prev) => ({ ...prev, [name]: !isValid }));
    } else {
      setIsConnectionSucceeded(false);
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const secretResponse = await addSecret(formData);
      console.log(secretResponse);
      if (secretResponse.status === 201 || secretResponse.status === 200) {
        enqueueSnackbar(secretResponse?.data, {
          variant: 'success',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
        handleClose();
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      if (error.response.status === 403) {
        enqueueSnackbar(`You don't have Permission !!`, {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Test Connection Failed', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }

    setLoading(false);
    console.log('Connecting with:', formData);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const testDatabaseConnection = async (e) => {
    e.preventDefault();
    console.log('Testing connection');
    setLoading(true);
    try {
      const response = await testDbConnection(formData);
      if (response.status === 200) {
        enqueueSnackbar('Test Connection Successful', {
          variant: 'success',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
      setIsConnectionSucceeded(true);
    } catch (error) {
      setLoading(false);
      if (error.response.status === 403) {
        enqueueSnackbar(`You don't have Permission !!`, {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } else {
        enqueueSnackbar('Test Connection Failed', {
          variant: 'error',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      }
    }
    setLoading(false);
  };
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {service?.name} Connection
        <IconButton onClick={handleClose} size="small" sx={{ color: 'red' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <form autoComplete="off" onSubmit={testDatabaseConnection}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            {/* <TextField
              label="Connection Name"
              name="secretName"
              value={formData.secretName}
              onChange={handleChange}
              required
              fullWidth
            /> */}

            <TextField
              label="Connection Name"
              name="secretName"
              value={formData.secretName}
              onChange={handleChange}
              required
              fullWidth
              inputProps={{ maxLength: 30 }}
              error={errors.secretName}
              helperText={
                errors.secretName
                  ? AWS_CONFIG_TYPE
                    ? 'Must start with a letter. Use only lowercase letters, numbers, and underscores (max 30 chars)'
                    : 'Must start with a letter. Use only lowercase letters, numbers, and hyphens (max 30 chars)'
                  : ''
              }
            />

            <Divider sx={{ my: 1, borderColor: '#ccc' }} />
            <TextField
              label="Engine"
              name="engine"
              value={formData.engine}
              onChange={handleChange}
              disabled
              required
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField label="Host Name" name="host" value={formData.host} onChange={handleChange} required fullWidth />
            <TextField
              label="Port"
              name="port"
              value={formData.port}
              onChange={handleChange}
              type="number"
              required
              fullWidth
            />
            <TextField
              label="Username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              fullWidth
            />
            <TextField
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              type={showPassword ? 'text' : 'password'}
              autoComplete="new-password"
              required
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {showPassword ? (
                      <VisibilityOff onClick={handleClickShowPassword} style={{ cursor: 'pointer' }} />
                    ) : (
                      <Visibility onClick={handleClickShowPassword} style={{ cursor: 'pointer' }} />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Service Name"
              name="serviceName"
              value={formData.serviceName}
              onChange={handleChange}
              required
              fullWidth
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button type="submit" variant="contained" color="primary" sx={{ mr: 2 }}>
              Test
            </Button>

            <Button
              type="button"
              onClick={handleSubmit}
              variant="contained"
              color="success"
              disabled={!isConnectionSucceeded}
            >
              Save
            </Button>
          </Box>
        </form>
      </DialogContent>
      {loading && <LoadingIcon />}
    </Dialog>
  );
};

OracleDBConnectorForm.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  service: PropTypes.object,
};

export default OracleDBConnectorForm;
